import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';
import { SIDEBAR_POSITIONS } from 'components/Sidebar/sidebarSettings';
import { NavButton } from './NavButton';

const footerStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 'auto',
  },
}));

export const SidebarFooter = ({
  handleBack,
  handleSkip,
  hidePrevious,
  hideSkip,
}) => {
  const classes = footerStyles();
  return (
    <Box className={classes.root}>
      {hidePrevious ? null : <NavButton to={SIDEBAR_POSITIONS.LEFT} content="questionnaire.button.previous" onClick={handleBack} />}
      {hideSkip ? null : <NavButton to={SIDEBAR_POSITIONS.RIGHT} content="questionnaire.button.skip" onClick={handleSkip} />}
    </Box>
  );
};

SidebarFooter.propTypes = {
  handleBack: PropTypes.func.isRequired,
  handleSkip: PropTypes.func.isRequired,
  hidePrevious: PropTypes.bool,
  hideSkip: PropTypes.bool,
};
